/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * The polygon of the customized results area in WKT format, must be WGS84.
 * @export
 * @interface CustomizedResultAreaGeometry
 */
export interface CustomizedResultAreaGeometry {
  /**
   *
   */
  type?: CustomizedResultAreaGeometryTypeEnum;
  /**
   *
   */
  coordinates?: Array<Array<Array<number>>>;
}

/**
 * @export
 */
export const CustomizedResultAreaGeometryTypeEnum = {
  Polygon: "Polygon",
} as const;
export type CustomizedResultAreaGeometryTypeEnum =
  (typeof CustomizedResultAreaGeometryTypeEnum)[keyof typeof CustomizedResultAreaGeometryTypeEnum];

/**
 * Check if a given object implements the CustomizedResultAreaGeometry interface.
 */
export function instanceOfCustomizedResultAreaGeometry(
  value: object
): value is CustomizedResultAreaGeometry {
  return true;
}

export function CustomizedResultAreaGeometryFromJSON(json: any): CustomizedResultAreaGeometry {
  return CustomizedResultAreaGeometryFromJSONTyped(json, false);
}

export function CustomizedResultAreaGeometryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CustomizedResultAreaGeometry {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"] == null ? undefined : json["type"],
    coordinates: json["coordinates"] == null ? undefined : json["coordinates"],
  };
}

export function CustomizedResultAreaGeometryToJSON(json: any): CustomizedResultAreaGeometry {
  return CustomizedResultAreaGeometryToJSONTyped(json, false);
}

export function CustomizedResultAreaGeometryToJSONTyped(
  value?: CustomizedResultAreaGeometry | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    coordinates: value["coordinates"],
  };
}
